import { render } from "./PipelineWizard.vue?vue&type=template&id=bc12f948&scoped=true"
import script from "./PipelineWizard.vue?vue&type=script&lang=js"
export * from "./PipelineWizard.vue?vue&type=script&lang=js"

import "./PipelineWizard.vue?vue&type=style&index=0&id=bc12f948&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc12f948"]])

export default __exports__